import { render, staticRenderFns } from "./upload-group-element.vue?vue&type=template&id=22c8fafd&scoped=true"
import script from "./upload-group-element.vue?vue&type=script&lang=js"
export * from "./upload-group-element.vue?vue&type=script&lang=js"
import style0 from "./upload-group-element.vue?vue&type=style&index=0&id=22c8fafd&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"
import style1 from "./upload-group-element.vue?vue&type=style&index=1&id=22c8fafd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8fafd",
  null
  
)

export default component.exports